import './App.css'
import Navbar from './commons/components/Navbar'
import Router from './commons/routes'
import Footer from './commons/components/Footer'
import { BrowserRouter } from 'react-router-dom'
import { userContext } from './commons/context'
import { useEffect, useState } from 'react'
import 'react-toastify/dist/ReactToastify.css'
import { useDispatch } from 'react-redux'
import { getUserToken } from './commons/redux/actions/user.actions'
import { useSelector } from 'react-redux'

function App() {
  const [userData, setUserData] = useState()
  const dispatch = useDispatch()
  const token = localStorage.getItem('token') || null
  const data = useSelector((state) => state.userReducer)
  useEffect(() => {
    if (typeof window != 'undefined' && token && !data.user) {
      dispatch(getUserToken(token))
      setUserData(data.user)
    }
  }, [token, data.user, dispatch])
  useEffect(() => {
    if (data.user && !userData) {
      setUserData(data.user)
    }
  }, [data.user, userData])



  
  return (
    <div className="w-full">
      <userContext.Provider value={{ userData, setUserData }}>
        <BrowserRouter>
          <Navbar />
          <div className="App mx-auto">
            <Router />
          </div>
          <Footer />
        </BrowserRouter>
      </userContext.Provider>
    </div>
  )
}

export default App
